module.exports = __webpack_public_path__ + "img/index_mobile_middle_pic_2.fed9b1eb.png";